import api from "PFCore/api";
import { gidFor } from "PFCore/helpers/gid";
import { Attachment, GIdTargetId, GIdTargetType } from "PFTypes";

export type FetchAttachmentsPayload = {
  targetId: GIdTargetId;
  targetType: GIdTargetType;
};

export type FetchAttachmentsResponse = {
  entries: Attachment[];
  meta: { total: number };
};

export const fetchAttachments = ({
  targetType,
  targetId
}: FetchAttachmentsPayload): Promise<FetchAttachmentsResponse> => {
  const gid = gidFor(targetType, targetId);

  return api({
    url: "attachments",
    params: { target: gid }
  });
};
